import type { Language } from '$lib/types/Language';

export const getLabel = (label: 'Days' | 'Hours' | 'Minutes' | 'Seconds', language: Language) => {
    const labels = {
        Days: ['Days', 'Tage'],
        Hours: ['Hours', 'Stunden'],
        Minutes: ['Minutes', 'Minuten'],
        Seconds: ['Seconds', 'Sekunden'],
    };
    const [en, de] = labels[label];

    return language === 'en' ? en : de;
};
